
import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import Navbar from "../../components/Navbar.js";
import Select from "react-select";
import LOGO from "../../assets/images/logo.png";
import Pagination from '@mui/material/Pagination';
import {
    locale,
    tokens,
    select_style,
    required,
    // alert
    success,
    success_url,
    alert,
    alert_url,
    // function
    logout,
    number_zero,
    format_date,
    toFixed,
    total,
    validate,
    random_charactor,
    float,
    // api
    GET,
    POST,
    PUT,
    DELETE,
    error_message,
    // storage
    removeStorage,
    getStorage,

    validate_email,
    validate_th,
    validate_en,
    validate_en_number,

    LinktoBase64,
    // component
    DatePicker,
} from "../../components/CustomComponent.js";

import "../../components/global.js";
import "../../assets/css/bootstrap.css";
import "../../assets/css/index.css";

export default class Dashboard extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            data: null,

            page: 1,
            data_search: ""
        }
    }
    async componentDidMount() {
        this.Get();
    }
    Get = async () => {
        this.setState({ loading: true });
        let body = {
            page: this.state.page,
            data_search: this.state.data_search,
            payment_id: ""
        }
        let result = await GET(tokens, "v1/TH/transaction/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log(result);
            this.setState({ data: result });
        }
        this.setState({ loading: false });
    }
    render() {
        return (
            <div className="w-100 min-vh-100 fade-in">
                {this.state.loading && (<div className="spinner-container"> <div className="loading-spinner"></div> </div>)}
                <Navbar page1="หน้าหลัก" page2="Log" />
                {/* BODY */}
                <div className="body bg-light min-vh-100">
                    <div className="p-3">
                        {/* หัวข้อ และ ปุ่มเพิ่ม */}
                        <div className="d-flex row mx-0 align-items-center justify-content-between test">
                            <h3 className="mb-3"><b>Log</b></h3>
                        </div>
                        <div className="w-100 card border-0">
                            <div className="d-flex mx-0 px-3 pt-3 mb-3">
                                <input
                                    className="form-control wpx-250 bg-contain border-0 mx-1"
                                    type="text"
                                    placeholder=""
                                    onChange={(e) => { this.setState({ data_search: e.target.value }) }}
                                    onKeyUp={(e) => {
                                        if (e.key === "Enter") {
                                            this.setState({ page: 1 });
                                            setTimeout(() => {
                                                this.Get();
                                            }, 10);
                                        }
                                    }}
                                    value={this.state.data_search}
                                />
                                <button className="btn btn-orange mx-1" onClick={() => {
                                    this.setState({ page: 1 });
                                    setTimeout(() => {
                                        this.Get();
                                    }, 10);
                                }}>
                                    ค้นหา
                                </button>
                                <button className="btn btn-outline-orange mx-1" onClick={() => {
                                    this.setState({ page: 1, data_search: "" });
                                    setTimeout(() => {
                                        this.Get();
                                    }, 10);
                                }}>
                                    รีเซ็ต
                                </button>
                            </div>
                            <div className="table-responsive">
                                <table className="table table-borderless table-striped">
                                    <thead className="bg-primary">
                                        <tr>
                                            <th className="text-center text-white">วันเวลา</th>
                                            <th className="text-center text-white">สาขา</th>
                                            <th className="text-left text-white">รายการ</th>
                                            <th className="text-center text-white">เลขที่เอกสาร</th>
                                            <th className="text-left text-white">ชื่อผู้ทำรายการ</th>
                                            <th className="text-center text-white">เมนู</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.data && this.state.data.data.map((item, index) => (
                                            <tr key={index}>
                                                <td className="text-center">{item.datetime_create ? format_date(item.datetime_create, "dd/mm/yyyy hh:mm น.") : "-"}</td>
                                                <td className="text-center">{item.branch_name ? item.branch_name : "-"}</td>
                                                <td className="text-left">{item.event_detail ? item.event_detail : "-"}</td>
                                                <td className="text-center">{item.document_number ? item.document_number : "-"}</td>
                                                <td className="text-left">{item.full_name ? item.full_name : "-"}</td>
                                                <td className="text-center">{item.menu ? item.menu : "-"}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                {/* pagination */}
                                {this.state.data && (
                                    <div className="d-flex flex-wrap justify-content-between w-100 px-3 mt-3">
                                        <label>
                                            แสดง {this.state.data.end_index} รายการ จาก {this.state.data.count} รายการ
                                        </label>
                                        <Pagination
                                            count={this.state.data.page_number}
                                            page={this.state.data.page}
                                            color="primary"
                                            showFirstButton
                                            shape="rounded"
                                            showLastButton
                                            onChange={(event, value) => {
                                                this.setState({ page: value })
                                                setTimeout(() => { this.Get() }, 5)
                                            }} />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        )
    }
}
